import * as React from "react";
const SvgFiRrStarSharpHalf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M6.635 23.228a3.34 3.34 0 0 1-1.92-.625c-.877-.631-1.714-1.956-1.18-3.608l1.353-4.184-3.561-2.603c-1.4-1.021-1.5-2.584-1.16-3.612.329-1.02 1.33-2.219 3.064-2.219H7.6L8.927 2.24C9.457.587 10.913 0 11.999 0a1 1 0 0 1 1 1v17.786a1 1 0 0 1-.408.806l-4.075 2.995c-.624.461-1.274.641-1.882.641M3.232 8.377c-.806 0-1.082.588-1.163.84-.05.148-.247.876.438 1.375l4.145 3.031a1 1 0 0 1 .36 1.115L5.44 19.61c-.262.81.326 1.284.447 1.37.123.089.763.5 1.444-.003L11 18.28V2.5a1.4 1.4 0 0 0-.168.352l-1.55 4.832a1 1 0 0 1-.952.694h-5.1z"
    />
  </svg>
);
export default SvgFiRrStarSharpHalf;
